<template>
  <!-- contract manage -->
  <div>
    <div class="right-box">
      <h1 class="com-title" :style="routerName">
        <i></i>
        文件管理{{ nameTextShow }}
        <span class="ms">
          /
          {{
          [1, 2, 3].includes(enterpriseSubjectType)
          ? ["", "企业主体账号发给他人的", "企业主体账号待签的", "企业主体账号已结束的"][enterpriseSubjectType]
          : "查看当前账号权限范围内的合同"
          }}
        </span>
      </h1>
      <div class="contract-box">
        <!-- contract table -->
        <el-row type="flex">
          <el-col style="display: flex; justify-content: flex-end">
            <el-form :inline="true" :model="filterModel" size="small" class="demo-form-inline">
              <el-form-item label class="margin-bottom-15">
                <el-select
                  style="width: 140px"
                  v-model="filterModel.keywordType"
                  placeholder="请选择状态"
                >
                  <el-option label="文件名称" :value="1"></el-option>
                  <el-option label="签署人名称" :value="4"></el-option>
                  <el-option label="内部发起人" v-show="!enterpriseSubjectType" :value="2"></el-option>
                  <el-option label="内部签署人" v-show="!enterpriseSubjectType" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label class="margin-bottom-15">
                <el-input v-model="filterModel.keyword" placeholder="请输入" style="width: 140px"></el-input>
              </el-form-item>
              <el-form-item label class="margin-bottom-15">
                <!-- 改版后的状态 -->
                <el-select style="width: 140px" v-model="filterModel.status" placeholder="请选择状态">
                  <el-option
                    v-for="(item, index) in statusEnum"
                    :label="item.label"
                    :value="item.value"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label class="margin-bottom-15">
                <el-date-picker
                  v-model="filterModel.timePicker"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :default-time="['00:00:00', '23:59:59']"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 210px"
                />
              </el-form-item>
              <el-form-item class="margin-bottom-15">
                <el-button @click="filterSearch">查询</el-button>
              </el-form-item>
              <el-form-item style="margin-right: 0px" class="margin-bottom-15">
                <el-button @click="rest">重置</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!-- table -->
        <el-row>
          <!-- <el-col :span="24"> -->
          <el-table
            class="data-list1"
            :data="tableList"
            style="border: 1px solid #eeeeee; border-bottom: 0"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            :header-cell-style="{
              background: '#f9f9f9',
              color: '#333333',
              fontWeight: '600',
            }"
          >
            <!--    企业成员的        -->
            <el-table-column type="selection" width="55" v-if="mainAccount" />
            <el-table-column min-width="300" label="文件名称" prop="contractName" show-overflow-tooltip>
              <template slot-scope="scope">
                <template v-if="!enterpriseSubjectType">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      position: relative;
                      padding-top: 10px;
                    "
                  >
                    <span class="multiFile" v-if="scope.row.files > 1">多</span>
                    <apply-name-member
                      :enterpriseSubjectType="enterpriseSubjectType"
                      @handleInsurance="
                        handleInsurance({
                          insureState: scope.row.insureState,
                          preservationId: scope.row.preservationId,
                          signNo: scope.row.signInfoNo,
                        })
                      "
                      applyType="signList"
                      :signInfo="{
                        status: scope.row.signStatus,
                        signNo: scope.row.signInfoNo,
                        applyNo: scope.row.applyNo,
                        name: scope.row.contractName,
                        row: scope.row,
                        selfSign: scope.row.selfSign,
                        insureState: scope.row.insureState,
                        preservationId: scope.row.preservationId,
                        multiFile: scope.row.multiFile,
                      }"
                    ></apply-name-member>
                  </div>
                  <p class="textEllipsis">
                    发起方：
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.ebqUserName"
                      placement="bottom-start"
                    >
                      <span>{{ scope.row.ebqUserName }}</span>
                    </el-tooltip>
                  </p>
                  <p class="textEllipsis">
                    发起时间：{{ scope.row.createTime | formatDateHM }}
                    <img
                      src="/images/icon/dingIcon.png"
                      alt="钉钉"
                      width="20px"
                      v-if="scope.row.fromDingTalk && scope.row.fromDingTalk == 1 && !isInDingTalk"
                    />
                  </p>
                </template>
                <template v-if="enterpriseSubjectType === 1">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      position: relative;
                      padding-top: 10px;
                    "
                  >
                    <span class="multiFile" v-if="scope.row.files > 1">多</span>
                    <corp-apply-name
                      :enterpriseSubjectType="enterpriseSubjectType"
                      applyType="iApplyList"
                      :signInfo="{
                        signStatus: scope.row.signStatus,
                        selfSign: scope.row.selfSign,
                        selfApprove: scope.row.selfApprove,
                        signNo: scope.row.signNo,
                        contractName: scope.row.contractName,
                        applyNo: scope.row.applyNo,
                        approveId: scope.row.approveId,
                        multiFile: scope.row.multiFile,
                        aiCorpUserIdFlag: scope.row.aiCorpUserIdFlag,
                      }"
                    />
                    <span
                      v-if="scope.row.vpresId"
                      class="color-success"
                      style="
                        font-size: 12px;
                        color: rgba(41, 2, 2, 0.65);
                        cursor: default;
                        flex: 1;
                        min-width: 150px;
                        padding-top: 5px;
                      "
                    >
                      &nbsp;&nbsp;备案号：{{ scope.row.vpresId }}
                      <!--<img src="../../../static/images/record.png" alt="">-->
                    </span>
                  </div>

                  <p class="textEllipsis">发起方：{{ scope.row.ebqUserName }}</p>
                  <p class="textEllipsis">
                    发起时间：{{ scope.row.createTime | formatDateHM }}
                    <img
                      src="/images/icon/dingIcon.png"
                      alt="钉钉"
                      width="20px"
                      v-if="scope.row.fromDingTalk && scope.row.fromDingTalk == 1 && !isInDingTalk"
                    />
                  </p>
                </template>
                <template v-if="enterpriseSubjectType === 2 || enterpriseSubjectType === 3">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      position: relative;
                      padding-top: 10px;
                    "
                  >
                    <span class="multiFile" v-if="scope.row.files > 1">多</span>
                    <apply-name
                      :enterpriseSubjectType="enterpriseSubjectType"
                      @handleInsurance="
                        handleInsurance({
                          insureState: scope.row.insureState,
                          preservationId: scope.row.preservationId,
                          signNo: scope.row.signInfoNo,
                        })
                      "
                      applyType="signList"
                      :signInfo="{
                        status: scope.row.applySignStatus,
                        signNo: scope.row.signInfoNo,
                        applyNo: scope.row.applyNo,
                        name: scope.row.contractName,
                        row: scope.row,
                        selfSign: scope.row.selfSign,
                        insureState: scope.row.insureState,
                        preservationId: scope.row.preservationId,
                        multiFile: scope.row.multiFile,
                      }"
                    ></apply-name>
                  </div>

                  <p class="textEllipsis">
                    发起方：
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.ebqUserName"
                      placement="bottom-start"
                    >
                      <span>{{ scope.row.ebqUserName }}</span>
                    </el-tooltip>
                  </p>
                  <p class="textEllipsis">发起时间：{{ scope.row.applyCreateTime | formatDateHM }}</p>
                  <img
                    src="/images/icon/dingIcon.png"
                    alt="钉钉"
                    width="20px"
                    v-if="scope.row.fromDingTalk && scope.row.fromDingTalk == 1 && !isInDingTalk"
                  />
                </template>
              </template>
            </el-table-column>
            <el-table-column label="签署方" min-width="250" prop="signInfoVOS">
              <template slot-scope="scope">
                <template v-if="!enterpriseSubjectType">
                  <el-tooltip placement="bottom-start">
                    <div
                      slot="content"
                      v-for="(item, inx) in scope.row.signInfoVOS"
                      style="
                        display: flex;
                        align-items: center;
                        padding-bottom: 5px;
                      "
                      :key="`qs${inx}`"
                    >
                      <span
                        v-if="item.orderNum && item.orderNum >= 1"
                        style="
                          margin-right: 5px;
                          display: block;
                          width: 13px;
                          height: 13px;
                          border-radius: 50%;
                          color: #ffffff;
                          border: 1px solid #ffffff;
                          text-align: center;
                          line-height: 13px;
                          font-size: 12px;
                        "
                      >{{ item.orderNum }}</span>
                      <span v-else style="color: #ffffff; margin-right: 5px">·</span>
                      <!--<div style="color: #ffffff;font-size: 12px;">【{{item.signStatus === 0?'未签署':item.signStatus === 1?'已签署':'已拒签'}}】</div>-->
                      <p class="textEllipsis">{{ item.signatoryFullName }}</p>
                    </div>
                    <div>
                      <p class="textEllipsis">{{ scope.row.signInfoVOS[0].signatoryFullName }}</p>
                      <p
                        class="textEllipsis"
                        v-if="scope.row.signInfoVOS.length > 1"
                      >{{ scope.row.signInfoVOS[1].signatoryFullName }}</p>
                      <template>
                        <p
                          class="textEllipsis"
                          v-if="(scope.row.signInfoVOS.length === 3)"
                        >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                        <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
                      </template>
                    </div>
                  </el-tooltip>
                </template>
                <template v-if="enterpriseSubjectType === 1">
                  <el-tooltip placement="bottom-start">
                    <div
                      slot="content"
                      v-for="(item, index) in scope.row.signInfoVOS"
                      :key="index"
                      style="
                        display: flex;
                        align-items: center;
                        padding-bottom: 5px;
                      "
                    >
                      <span
                        v-if="item.orderNum && item.orderNum >= 1"
                        style="
                          display: block;
                          width: 13px;
                          height: 13px;
                          border-radius: 50%;
                          color: #ffffff;
                          border: 1px solid #ffffff;
                          text-align: center;
                          line-height: 13px;
                          font-size: 12px;
                        "
                      >{{ item.orderNum }}</span>
                      <span v-else style="color: #ffffff">·</span>
                      <div style="color: #ffffff; font-size: 12px">
                        【{{
                        item.signStatus === 0 || item.signStatus === -1
                        ? "未签署"
                        : item.signStatus === 1
                        ? "已签署"
                        : "已拒签"
                        }}】
                      </div>
                      <p style="color: #ffffff; font-size: 12px">{{ item.signatoryFullName }}</p>
                    </div>
                    <div>
                      <p class="textEllipsis">{{ scope.row.signInfoVOS[0].signatoryFullName }}</p>
                      <p
                        class="textEllipsis"
                        v-if="scope.row.signInfoVOS.length > 1"
                      >{{ scope.row.signInfoVOS[1].signatoryFullName}}</p>
                      <template>
                        <p
                          class="textEllipsis"
                          v-if="(scope.row.signInfoVOS.length === 3)"
                        >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                        <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
                      </template>
                    </div>
                  </el-tooltip>
                </template>
                <template v-if="enterpriseSubjectType === 2 || enterpriseSubjectType === 3">
                  <el-tooltip placement="bottom-start">
                    <div
                      slot="content"
                      v-for="(item, inx) in scope.row.signInfoVOS"
                      style="
                        display: flex;
                        align-items: center;
                        padding-bottom: 5px;
                      "
                      :key="`qs${inx}`"
                    >
                      <span
                        v-if="item.orderNum && item.orderNum >= 1"
                        style="
                          display: block;
                          width: 13px;
                          height: 13px;
                          border-radius: 50%;
                          color: #ffffff;
                          border: 1px solid #ffffff;
                          text-align: center;
                          line-height: 13px;
                          font-size: 12px;
                        "
                      >{{ item.orderNum }}</span>
                      <span v-else style="color: #ffffff">·</span>
                      <div style="color: #ffffff; font-size: 12px">
                        【{{
                        item.signStatus === 0 || item.signStatus === -1
                        ? "未签署"
                        : item.signStatus === 1
                        ? "已签署"
                        : "已拒签"
                        }}】
                      </div>
                      <p style="color: #ffffff; font-size: 12px">{{ item.signatoryFullName }}</p>
                    </div>
                    <div>
                      <p class="textEllipsis">{{ scope.row.signInfoVOS[0].signatoryFullName }}</p>
                      <p
                        class="textEllipsis"
                        v-if="scope.row.signInfoVOS.length > 1"
                      >{{ scope.row.signInfoVOS[1].signatoryFullName }}</p>
                      <template>
                        <p
                          class="textEllipsis"
                          v-if="(scope.row.signInfoVOS.length === 3)"
                        >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                        <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
                      </template>
                    </div>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="120" prop="signStatus">
              <template slot-scope="scope">
                <template v-if="!enterpriseSubjectType">
                  <p
                    :class="
                      signStatusFilters[scope.row.signStatus]
                        ? signStatusFilters[scope.row.signStatus].className
                        : ''
                    "
                  >
                    {{signStatusFilters[scope.row.signStatus]
                    ? signStatusFilters[scope.row.signStatus].text
                    : ""
                    }}
                  </p>
                </template>
                <template v-if="enterpriseSubjectType === 1">
                  <template v-if="scope.row.signStatus === -3">
                    <span v-if="scope.row.selfApprove === 1" class="red">待审批</span>
                    <span v-else class="blue">待审批</span>
                  </template>
                  <template v-else-if="scope.row.signStatus === -4">
                    <p class="orange">审批驳回</p>
                  </template>
                  <template v-else-if="scope.row.signStatus === 0">
                    <p v-if="scope.row.selfSign === 1" class="dot-red">待签署</p>
                    <p v-else class="blue">待ta签</p>
                  </template>
                  <template v-else-if="scope.row.signStatus === 1">
                    <span class="green">已完成</span>
                  </template>
                  <template v-else-if="scope.row.signStatus === 2">
                    <span class="orange">已拒签</span>
                  </template>
                  <template v-else-if="scope.row.signStatus === 4">
                    <span class="orange">已作废</span>
                  </template>
                  <template v-else-if="scope.row.signStatus === -5">
                    <span class="grey">已撤销</span>
                  </template>
                  <template v-else-if="scope.row.signStatus === -6">
                    <span class="grey">已过期</span>
                  </template>
                </template>
                <template v-if="enterpriseSubjectType === 2 || enterpriseSubjectType === 3">
                  <span v-if="scope.row.applySignStatus === -1" class="red">处理中</span>
                  <template v-else-if="scope.row.applySignStatus === 0">
                    <span v-if="scope.row.selfSign === 1" class="dot-red">待签署</span>
                    <span v-else class="blue">待ta签</span>
                  </template>
                  <span v-else-if="scope.row.applySignStatus === 1" class="green">已完成</span>
                  <span v-else-if="scope.row.applySignStatus === 2" class="orange">已拒签</span>
                  <span v-else-if="scope.row.applySignStatus === 4" class="orange">已作废</span>
                  <span v-else-if="scope.row.applySignStatus === -5" class="grey">已撤销</span>
                  <span v-else-if="scope.row.applySignStatus === -6" class="grey">已过期</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope" v-if="!(scope.row.applyNo && scope.row.applyNo.startsWith('APLO'))">
                <template v-if="[1,4].includes(scope.row.signStatus || scope.row.applySignStatus)">
                  <existing-evidence
                    requestType="memberContract"
                    :enterpriseSubjectType="enterpriseSubjectType"
                    @copyTextToQueryEmit="copyTextToQuery"
                    :rowData="scope.row"
                  ></existing-evidence>
                  <template v-if="scope.row.applySignCreateType !== 0 && enterpriseSubjectType">
                    <p
                      class="com-normal-btn"
                      v-if="[1].includes(scope.row.signStatus || scope.row.applySignStatus) && !scope.row.terminationApplyNo"
                      @click="invalidation(scope.row)"
                    >合同作废</p>
                    <p
                      class="com-normal-btn"
                      v-if="[4].includes(scope.row.signStatus || scope.row.applySignStatus) || ([1].includes(scope.row.signStatus || scope.row.applySignStatus) && scope.row.terminationApplyNo)"
                      @click="toApplyDetail(scope.row)"
                    >查看作废协议</p>
                  </template>
                  <el-dropdown
                    v-if="!enterpriseSubjectType"
                    trigger="click"
                    @visible-change="visiChange($event, scope.row.applyId)"
                  >
                    <span class="com-normal-btn">
                      更多操作
                      <i
                        :class="
                      visiDown.status &&
                      visiDown.rowApplyId == scope.row.applyId
                        ? 'el-icon-caret-top'
                        : 'el-icon-caret-bottom'
                    "
                        class="com-normal-btn el-icon--right"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" style="background-color: #f5f6f6">
                      <more-button
                        :rowData="scope.row"
                        :enterpriseSubjectType="enterpriseSubjectType"
                        :showMoreBtn="true"
                        :Cancancel="true"
                        :hideArbitrate="true"
                        @btnMethodFn="openLYDialog"
                      ></more-button>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </template>
            </el-table-column>
            <no-data text="暂无数据" slot="empty" />
          </el-table>
          <!-- </el-col> -->
        </el-row>
        <!-- pagination -->
        <!--分页栏-->
        <el-row class="pageation">
          <el-col :span="2" style="padding: 30px 0 0 0">
            <el-button v-if="mainAccount" @click="batchDown" size="mini">下载</el-button>
          </el-col>
          <el-col :span="22" style="padding: 30px 0 0 0" class="page-flex-end">
            <el-pagination
              small
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="filterModel.itemPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="filterModel.pageSize"
              layout="sizes, prev, pager, next, total"
              :total="filterModel.pageTotal"
            />
            <el-go
              :page-size="filterModel.pageSize"
              :total="filterModel.pageTotal"
              @current-change="handleCurrentChange"
            ></el-go>
          </el-col>
        </el-row>
      </div>
    </div>
    <certiServiceDialog
      v-if="cSDialogVisible"
      :dialogVisible="cSDialogVisible"
      :param="cSDialogData"
      @setCSDialogData="onSetCSDialogData"
    ></certiServiceDialog>
    <selectSubjectDialog
      v-if="sSDialogVisible"
      :dialogVisible="sSDialogVisible"
      :param="sSDialogData"
      @setSSDialogData="onSetSSDialogData"
    ></selectSubjectDialog>
    <!--履约文件-->
    <el-dialog title="履约文件" :visible.sync="lYDialogVisible" width="850px" class="ly-info">
      <el-tabs v-model="activeName" class="ly-mask" @tab-click="handleClick">
        <el-tab-pane label="上传原文件" name="1">
          <p class="tips">支持常见图片、文档、视频、音频、压缩包格式，上传后会保存原文件，单个文件大小不超过30MB</p>
          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input ref="referenceUpload" type="file" class="file-ipt" @change="handleInputChange" />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/file-icon.png" />
                <div class="msk">
                  <span class="des">上传人：{{ item.userName }} -{{ item.accountName }}</span>
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" :href="downloadLYFile(item.file)">下载</a>
                <a v-if="isDoc(item)" class="has-hover" @click="previewDoc(item)">预览</a>
                <a v-if="isVideoOrImg(item)" class="has-hover" @click="previewVideOrImg(item)">预览</a>
                <a v-if="item.canDelete" class="has-hover" @click="delLYFile(item)">删除</a>
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传文件哈希" name="2">
          <p class="tips">格式没有限制，仅保存上传文件的特征值（哈希），不对文件本身做保存，单个文件大小不超过500M</p>

          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input
                ref="referenceUpload1"
                type="file"
                class="file-ipt"
                @change="handleInputChange"
              />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/hash-icon.png" />
                <div class="msk">
                  <span class="des">上传人：{{ item.userName }} -{{ item.accountName }}</span>
                  <br />
                  <span class="des" style="margin: 0">备案号：{{ item.presId }}</span>
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" @click="validLYFile(item)">验证</a>
                <a v-if="item.canDelete" class="has-hover" @click="delLYFile(item)">删除</a>
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="footer">
        <span class="num">
          文件数：
          <label>{{ lYDialogData.length }}</label>个
        </span>
        <el-button
          type="primary"
          size="small"
          class="cancel-btn"
          @click="lYDialogVisible = false"
        >关闭</el-button>
      </div>
    </el-dialog>
    <!--pdf文件预览-->
    <ViewFilesToDoc
      :visibleShow="visibleShowEnclosureDoc"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
    />
    <!--附件图片video预览显示-->
    <ViewFilesToImg
      :visibleShow="visibleShowEnclosure"
      :isRefresh="isRefresh"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      :imgList="getEnclosureImgList"
      @setViewFilesToImgDialogData="onSetViewFilesToImgDialogData"
      style="text-align: center"
    />
    <!--  提示展示批量签署时提醒签章   -->
    <el-dialog
      :visible.sync="nodeQueryVisible"
      width="800px"
      custom-class="data-dialog"
      destroy-on-close
    >
      <div class="node_header" slot="title">保全链节点查询</div>
      <p style="padding: 10px">当前合同备案号：{{ vpresId }}</p>
      <node-query :vpresId="vpresId" />
    </el-dialog>
  </div>
</template>

<script>
import nodeQuery from "@/components/signInfo/node-query";
import ViewFilesToImg from "@/components/viewFiles/ViewFilesToImg";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
import moreButton from "@/components/apply-list/more-button";
import CorpApplyName from "@/components/apply-list/corpContractName";
import existingEvidence from "@/components/apply-list/existing-evidence";
import ApplyNameMember from "@/components/apply-list/contract-name-member";
import ApplyName from "@/components/apply-list/contractName";
import { ApiMethods, postSignPage, postApplyPage, getFindFileDownload } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods, applyViewUrl } from "@/assets/js/http-serve/corp/http-methods";
import ElGo from "../../components/go/Go";
import CertiServiceDialog from "@/components/apply-list/certiServiceDialog";
import SelectSubjectDialog from "@/components/apply-list/selectSubjectDialog";
import CertiServicepopover from "@/components/apply-list/certiServicepopover";
import Bus from "@/plugins/bus.js";
import InsureController from "@/assets/js/http-serve/insuranceController";
import { gantConf, getPermInfo } from "../../assets/js/utils/jurisdiction";
import { isInDingTalk } from '@/assets/js/utils/ding-env';
import sha512Crypto from "js-sha512";
import { mapGetters } from 'vuex';
import GlobalConfig from "@/assets/js/config/global";

export default {
  name: "contract",
  components: {
    existingEvidence,
    ApplyNameMember,
    ElGo,
    CertiServiceDialog,
    SelectSubjectDialog,
    CertiServicepopover,
    CorpApplyName,
    ApplyName,
    moreButton,
    ViewFilesToDoc,
    ViewFilesToImg,
    nodeQuery,
  },
  data () {
    return {
      isInDingTalk,
      vpresId: '',
      nodeQueryVisible: false,
      //履约文件数据
      lYDialogVisible: false, //履约文件弹窗
      lYDialogData: [], //履约文件列表
      activeName: "1", //1：文件上传，2：hash值上传
      visibleShowEnclosure: false,
      visibleShowEnclosureDoc: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      isRefresh: true, // 预览附件时，强制刷新
      rowData: {},
      visiDown: { status: false, rowApplyId: "" },

      routerName: {
        fontSize: "16px",
        lineHeight: "36px",
        backgroundColor: "#fff",
        paddingLeft: "16px",
        fontWeight: "600",
        borderBottom: "solid 1px #E5E5E5"
      },
      gantConf,
      cSDialogVisible: false, //证书弹出框显示
      cSDialogData: {}, //证书弹出框数据
      sSDialogVisible: false, // 请选择出证主体身份弹出框显示
      sSDialogData: {}, //请选择出证主体身份数据
      selectContract: [],
      selectTreeNode: {}, // 选中的树节点
      // filter model
      filterModel: {
        departmentId: "", // 部门id
        keywordType: 1, // 1 合同名称, 2 发起人, 3 签署人
        keyword: "",
        status: "",
        timePicker: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      tableList: [],
      // 签署状态
      signStatusFilters: {
        "-1": { text: "后台处理中", className: "dot-red" },
        "0": { text: "待签署", className: "dot-red" },
        "1": { text: "已完成", className: "dot-green" },
        "2": { text: "已拒签", className: "dot-red" },
        "4": { text: "已作废", className: "dot-orange" },
        "-3": { text: "待审批", className: "dot-purple" },
        "-4": { text: "审批驳回", className: "dot-orange" },
        "-5": { text: "已撤消", className: "dot-ccc" },
        "-6": { text: "已过期", className: "dot-ccc" }
      },
      enterpriseSubjectType: 0, //企业主体类型
    };
  },
  created () {
    this.evenFun();
  },
  methods: {
    // 查看作废协议（合同作废发起使用的是pc多文件发起，默认走多文件查看页面）
    toApplyDetail (row) {
      const { signNo, applySignCreateType, applySignDealType, terminationApplyNo } = row;
      if (applySignCreateType === 0 && applySignDealType === 6) return this.$message.error('该合同仅是hash保全，无法查看合同内容');
      if (this.$store.getters.authUser.identityAuth > -1) {
        let param = { signNo, applyNo: terminationApplyNo, multiFile: 1 };
        this.loading = this.$loading({ lock: true });
        const isCorp = this.currentAuthUser.corpUserId, path = '/applySign/toDetailMultiAnony';
        if ([1, 2, 3].includes(this.enterpriseSubjectType) || !isCorp) {
          ApiMethods.UserApplySignController.viewUrl({
            ...param,
            corpQuery: 1,
          })
            .then(({ data }) => {
              this.loading.close();
              data.approveId = '';
              let router = this.$router.resolve({ path, query: data });
              let href = window.location.origin + router.href;
              // 如果是钉钉环境就走 location 不要 window.open
              isInDingTalk ? location.href = href : window.open(href);
            })
            .catch(err => {
              this.loading.close();
              this.$message.error(err.description || "无法查看该合同");
              console.error("toApplyDetail: " + JSON.stringify(err));
            });
        } else {
          applyViewUrl(param)
            .then(url => {
              this.loading.close();
              isInDingTalk ? this.$router.push(url) : window.open(url);
            })
            .catch(err => {
              this.loading.close();
              this.$message.error(err.description || "无法查看该合同");
              console.error("toApplyDetail: " + JSON.stringify(err));
            });
        }
      }
    },
    /** 合同作废 */
    invalidation (row) {
      const { applySignCreateType: TYPE, terminationApplyNo } = row;
      if (terminationApplyNo) return this.$message.warning('已发起合同作废，请勿重复操作')
      if (TYPE === 0) return this.$message.warning("API合同不支持作废")
      /** 权限验证 */
      const perms = this.perms, KEY = gantConf.invalidation;
      const bool = perms.includes(KEY), isCorp = this.currentAuthUser.corpUserId;
      if ((!bool && isCorp)) {
        const Pinfo = getPermInfo(KEY)
        return this.$message.warning(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      // 暂存合同信息
      sessionStorage.setItem('NeedToBeInvalidated', JSON.stringify(row))
      // 跳转到合同作废页面
      const path = '/initiation/invalidation/cancellation';
      isInDingTalk ? this.$router.push({ path }) : window.open(`${GlobalConfig.domain.junziqianWebOp}${path}`, '_blank')
    },
    batchDown () {
      if (!this.selectContract || !this.selectContract.length)
        return this.$confirm("请先选择需要下载的签署。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });
      let batchApplyNosList = this.selectContract.filter((item) => {
        return item.signStatus === 1;
      })
      if (!batchApplyNosList.length) {
        return this.$message.error('只能下载已完成的文件')
      }
      let batchApplyNos = batchApplyNosList.reduce((pre, next) => {
        return pre + next.applyNo + ',';
      }, '')
      this.loading = true;
      ApiCorpMethods.CorpApplyContractController.cmdownloadBatch({
        applyNos: batchApplyNos,
      })
        .then(res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          this.downloadFile(res.data);
        })
        .finally(() => (this.loading = false));
    },
    async downloadFile (param) {
      param.fix = ".zip";
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        window.location.href = res.url;
      } else {
        this.$message.error(res.err);
      }
    },
    // 复制并查询
    copyTextToQuery (vpresId) {
      this.vpresId = vpresId;
      this.nodeQueryVisible = true;
    },
    // 执行预览图片视频关闭后参数回传
    onSetViewFilesToImgDialogData (data) {
      this.visibleShowEnclosure = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 预览履约文件图片或者视频
    previewVideOrImg (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 附件是否图片或视频
    isVideoOrImg (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PNG", "GIF", "JPG", "JPEG", "MP4", "WEBM", "OGG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData (data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    //下载履约文件
    downloadLYFile (item) {
      if (!item || item === "null" || item === "false")
        return "javascript:void(0)";
      if (item.fileName === "blob") {
        item.fileName = "attachment.png";
        item.fix = ".png";
      }
      return getFindFileDownload(item);
    },
    // 预览履约文件文档
    previewDoc (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosureDoc = true;
    },
    // 附件是否文档
    isDoc (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 获取附件后缀
    getEnclosureSuffix (item) {
      if (item.fileName) {
        let arr = item.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    //删除履约文件
    delLYFile (item) {
      this.$confirm("该操作删除后的文件将无法恢复，确认删除？", "系统提示", {
        showCancelButton: true,
        type: "info"
      })
        .then(() => {
          ApiMethods.PerformanceController.del({
            performanceId: item.performanceId
          })
            .then(data => {
              if (data.success) {
                this.setLYDialogData();
              } else {
                _this.$message.error(data.description);
              }
            })
            .catch(err => {
              this.$message.error(
                err.description || "删除失败，请刷新后再试！"
              );
            });
        })
        .catch(() => { });
    },
    //验证跳转
    validLYFile (item) {
      const url = "https://www.ebaoquan.org/query?type=2&bah=" + item.presId
      isInDingTalk ? location.href = url : window.open(url, "_blank");
    },
    // 上传履约文件
    handleInputChange: function (e) {
      e = e.target;
      let param = { file: e.files[0] };
      if (!param.file) return;
      var frm = new FormData();
      if (+this.activeName == 1) {
        if (param.file.size > 30 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过30M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        frm.append("file", param.file);
        frm.append("fileName", e.files[0].name);
        frm.append("uploadType", this.activeName);
        frm.append("applyNo", this.rowData.applyNo);
        ApiMethods.PerformanceController.upload(frm)
          .then(res => {
            this.$refs.referenceUpload.value = null;
            if (res.success) {
              this.$message.success("上传成功");
              this.setLYDialogData();
            } else {
              this.$message.error(res.description);
            }
          })
          .catch(e => {
            this.$message.error(e.description);
          });
      } else {
        if (param.file.size > 500 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过500M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        let _this = this;
        let targetFileHash = "";
        const sha512 = sha512Crypto.create();
        _this.fileSliceDeal(
          e.files[0],
          1024 * 1024 * 2,
          function (fileSlice) {
            sha512.update(fileSlice);
          },
          function () {
            targetFileHash = sha512.hex();
            frm.append("hashValue", targetFileHash);
            frm.append("fileName", e.files[0].name);
            frm.append("uploadType", _this.activeName);
            frm.append("applyNo", _this.rowData.applyNo);
            ApiMethods.PerformanceController.upload(frm)
              .then(res => {
                _this.$refs.referenceUpload1.value = null;
                if (res.success) {
                  _this.$message.success("上传成功");
                  _this.setLYDialogData();
                } else {
                  _this.$message.error(res.description);
                }
              })
              .catch(e => {
                _this.$message.error(e.description);
              });
          }
        );
      }
    },
    //哈希需要
    fileSliceDeal: function (file, sliceSize, dealFun, finishFun) {
      var startTime = new Date().getTime();
      var chunkSize = file.size;
      var chunks = 1;
      var blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      if (blobSlice) {
        chunkSize = sliceSize;
        chunks = Math.ceil(file.size / chunkSize);
      }
      var currentChunk = 0;
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        dealFun(e.target.result, currentChunk, chunks);
        currentChunk++;
        if (currentChunk < chunks) {
          loadNext();
        } else {
          finishFun();
        }
      };
      fileReader.onerror = function () {
        console.warn("oops, something went wrong.");
      };

      function loadNext () {
        var start = currentChunk * chunkSize;
        var end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(
          blobSlice ? blobSlice.call(file, start, end) : file
        );
      }

      loadNext();
    },
    //tab切花
    handleClick (tab) {
      this.activeName = tab.name;
      this.setLYDialogData();
    },
    visiChange (val, rowApplyId) {
      this.visiDown = {
        status: val,
        rowApplyId
      };
    },
    //履约文件相关 882需求新增
    openLYDialog (rowData) {
      this.lYDialogVisible = true;
      this.rowData = rowData;
      this.setLYDialogData();
    },
    //展示履约文件弹窗
    async setLYDialogData () {
      let _this = this;
      let param = {
        uploadType: this.activeName,
        applyNo: this.rowData.applyNo || ""
      };
      let res = await ApiMethods.PerformanceController.getList(param);
      if (res.success) {
        this.lYDialogData = res.data;
      } else {
        _this.$message.error(res.description);
      }
    },
    // 获取保险信息
    getInsureDetail (preservationId) {
      InsureController.detail(preservationId)
        .then(({ data }) => {
          if (data) {
            this.insureDetail = data;
            this.insureDialogVisible = true;
          }
        })
        .catch(err => {
          this.$message.warning(err.description);
          console.error("购买保险：" + JSON.stringify(err));
        });
    },
    // 获取合同保险单价
    getInsureProduct (signNo) {
      InsureController.productInfo(signNo)
        .then(({ data }) => {
          if (data) {
            this.insureProduct = {
              contractName: data.contractName,
              signNo: data.signNo,
              applyNo: data.applyNo,
              signatoryFullName: data.signatoryFullName,
              price: data.jzqInsurePreserveCost,
              insureYear: 1
            };
            this.insureProductDialog = true;
          }
        })
        .catch(err => {
          this.$message.warning(
            "已超过购保受理期。保险公司只在签署完成后的3个自然日内受理投保，超过时间将不予受理"
          );
        });
    },
    // 点击保险按钮
    handleInsurance (signInfo) {
      let insureState = signInfo.insureState;
      if (insureState === 0) {
        this.getInsureProduct(signInfo.signNo);
      } else if (insureState === 1 || insureState === 2) {
        this.getInsureDetail(signInfo.preservationId);
      }
    },
    // 创建兄弟传参监听
    evenFun () {
      Bus.$on("$queryContarct", param => {
        this.enterpriseSubjectType = 0;
        let { selectTreeNode, filterModel } = param;
        this.selectTreeNode = selectTreeNode;
        this.filterModel = filterModel;
        if (this.$route.query.selectedStatus) {
          this.filterModel.status = String(this.$route.query.selectedStatus);
        }
        this.queryTool();
      });
      Bus.$on('enterpriseSubjectEmit', param => {
        (this.filterModel = {
          departmentId: "", // 部门id
          keywordType: 1, // 1 合同名称, 2 发起人, 3 签署人
          keyword: "",
          status: "",
          timePicker: "",
          itemPage: 1,
          pageSize: 10,
          pageTotal: 0
        });
        this.filterModel.itemPage = 1;
        this.enterpriseSubjectType = param;
        this.enterpriseSubjectFn();
      })
    },
    /**
     *  签署方 string 分割为 签署方 array
     * */
    getQSF (str) {
      try {
        if (/\>/g.test(str)) {
          let arr = str.split(">").map((item, index) => {
            return {
              orderNum: index + 1,
              signatoryFullName: item
            };
          });
          return arr;
        }
        if (/\//g.test(str)) {
          let arr = str.split("/").map(item => {
            return {
              signatoryFullName: item
            };
          });
          return arr;
        }
        // 默认
        return [
          {
            signatoryFullName: str
          }
        ];
      } catch (e) {
        // 默认
        return [
          {
            signatoryFullName: str
          }
        ];
      }
    },
    async onGetCerti (rowData) {
      let _this = this;
      let _param;
      let viewUrlParam = {
        signNo: rowData.signNo || "",
        applyNo: rowData.applyNo || ""
      };
      let viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
        viewUrlParam
      );
      if (!viewUrlRes.success) {
        return _this.$message.error(viewUrlRes.description || "初始化数据失败");
      }
      _param = viewUrlRes.data;
      let certiRes = await ApiMethods.ApplySignController.certi(_param);
      if (certiRes.success) {
        _this.openCSDialog(certiRes.data);
      } else {
        let certiListRes = await ApiMethods.ApplySignController.certiList(
          _param
        );
        if (certiListRes.success) {
          if (!certiListRes.data || certiListRes.data.lengt == 0)
            return _this.$message.error("初始化数据失败");
          if (certiListRes.data.length === 1)
            return _this.openCSDialog(certiListRes.data[0]);
          if (certiListRes.data.length > 1)
            return _this.openSSDialog(certiListRes.data);
        } else {
          _this.$message.error(certiListRes.description);
        }
      }
    },
    openCSDialog (data) {
      this.cSDialogVisible = true;
      this.cSDialogData = data;
    },
    openSSDialog (data) {
      this.sSDialogVisible = true;
      this.sSDialogData = {
        certData: data
      };
    },
    onSetSSDialogData (data) {
      this.sSDialogVisible = data.sSDialogVisible;
      this.sSDialogData = {};
      if (data.sSDialogData) {
        this.openCSDialog(data.sSDialogData.certData);
      }
    },
    onSetCSDialogData (data) {
      this.cSDialogVisible = data.cSDialogVisible;
      this.cSDialogData = data.cSDialogData;
    },
    // table filter event about search and move org and add contract
    // 重置
    rest () {
      const { corpGroupId } = this.selectTreeNode
      this.filterModel = {
        departmentId: corpGroupId ? corpGroupId : "", // 部门id
        keywordType: 1, // 1 合同名称, 2 发起人, 3 签署人
        keyword: "",
        status: "",
        timePicker: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
      this.filterSearch();
    },
    // 搜索按钮
    filterSearch () {
      this.filterModel.itemPage = 1;
      this.queryTool();
    },
    //status状态码参数组合
    statusParamFn () {
      let obj = {}
      switch (this.filterModel.status) {
        case "0":
          obj["signStatusSet"] = "0";
          obj["selfSign"] = 1;
          break;
        case "1":
          obj["signStatusSet"] = "0";
          obj["selfSign"] = 0;
          break;
        case "2":
          obj["signStatusSet"] = "1";
          break;
        case "3":
          obj["signStatusSet"] = "2";
          break;
        case "4":
          obj["signStatusSet"] = "-6";
          break;
        case "5":
          obj["signStatusSet"] = "-5";
          break;
        case "6":
          obj["signStatusSet"] = "4";
          break;
      }
      return obj
    },
    //企业主体发起/签署的
    enterpriseSubjectFn () {
      let type = this.enterpriseSubjectType;
      let params = {};
      params.itemPage = this.filterModel.itemPage; // 页数
      params.pageSize = this.filterModel.pageSize; // 页长
      if (this.filterModel.keywordType === 1) {
        params.contractName = this.filterModel.keyword
      } else if (this.filterModel.keywordType === 4) {
        params.signatoryFullName = this.filterModel.keyword
      }
      if (this.filterModel.timePicker) {
        params.beginDate = this.filterModel.timePicker[0]; // 开始时间 yyyy-MM-dd,必须与endDate同时存在才生效
        params.endDate = this.filterModel.timePicker[1]; // 结束时间 yyyy-MM-dd,必须与beginDate同时存在才生效
      }
      let obj = this.statusParamFn();
      //发起的
      if (type === 1) {
        postApplyPage({
          ...params,
          ...obj,
          createType: 1,
          newVersion: 1,
          excludeSelfSign: 1,
          showAll: 1,
          corpQuery: 1,
        }).then(res => {
          this.resHanldFn(res);
        })
      } else if (type === 2) {
        postSignPage({
          ...params,
          ...obj,
          signStatusSet: '-1,0',
          corpQuery: 1,
        }).then(res => {
          this.resHanldFn(res);
        })
      } else if (type === 3) {
        postSignPage({
          ...params,
          // ...obj,
          signStatusSet: !this.filterModel.status ? '1,2,4,-5,-6' : this.filterModel.status == '6' ? '4' : this.filterModel.status,
          corpQuery: 1,
        }).then(res => {
          this.resHanldFn(res);
        })
      }
    },
    //列表数据回显
    resHanldFn (res) {
      if (res.code === "0") {
        this.tableList = res.data;
        this.filterModel.pageTotal = res.total;
      } else {
        this.tableList = [];
        this.filterModel.pageTotal = 0;
        if (this.$store.getters.authUser.identityAuth > -1) {
          this.$message.error(res.description || "获取合同数据列表失败");
        }
      }
    },
    // 获取合同数据
    queryTool () {
      if (this.enterpriseSubjectType) {
        return this.enterpriseSubjectFn();
      }
      let params = {};
      params.itemPage = this.filterModel.itemPage; // 页数
      params.pageSize = this.filterModel.pageSize; // 页长
      params.beginDate = "";
      params.endDate = "";
      if (this.filterModel.timePicker) {
        params.beginDate = this.filterModel.timePicker[0]; // 开始时间 yyyy-MM-dd,必须与endDate同时存在才生效
        params.endDate = this.filterModel.timePicker[1]; // 结束时间 yyyy-MM-dd,必须与beginDate同时存在才生效
      }
      // params.applyNo = this.filterModel.applyNo // 合同编号
      // keywordType: 1, // 1 合同名称, 2 发起人, 3 签署人
      params.contractName = ""; // 合同名
      params.initUserName = ""; // 内部发起人全称(只有全称能查出记录)
      params.signUserName = ""; // 内部签署人全称(只有全称能查出记录)
      if (this.filterModel.keywordType === 1) {
        params.contractName = this.filterModel.keyword;
      }
      if (this.filterModel.keywordType === 2) {
        params.initUserName = this.filterModel.keyword;
      }
      if (this.filterModel.keywordType === 3) {
        params.signUserName = this.filterModel.keyword;
      }
      if (this.filterModel.keywordType === 4) {
        params.signatory = this.filterModel.keyword;
      }
      params.signStatus = this.filterModel.status == '6' ? '4' : this.filterModel.status;

      params.corpGroupId = this.filterModel.departmentId; // 部门范围ID
      this.selectContract = undefined;
      ApiCorpMethods.ContractController.findByPage(params)
        .then(res => {
          this.resHanldFn(res);
          Bus.$emit("$formateTree", {
            number: this.filterModel.pageTotal,
            filterModel: this.filterModel
          });
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    // selection change event
    // 当选择项发生变化时会触发该事件
    handleSelectionChange (val) {
      this.selectContract = val;
    },
    // handle click look up contract evnet
    // 查看合同
    handleClickLookContract (row) {
      let params = {};
      let newWind = '';
      if (!isInDingTalk) newWind = window.open();
      params.applyNo = row.applyNo;
      params.multiFile = row.multiFile;
      ApiCorpMethods.ContractController.viewUrl(params)
        .then(res => {
          if (res.code === "0") {
            let { href } = row.multiFile
              ? this.$router.resolve({
                path: "/applySign/toDetailMultiAnony",
                query: Object.assign({}, res.data, {
                  approveId: row.approveId,
                  aiCorpUserIdFlag: row.aiCorpUserIdFlag
                })
              })
              : this.$router.resolve({
                path: "/applySign/toDetailAnony",
                query: Object.assign({}, res.data, {
                  approveId: row.approveId
                })
              });
            href = isInDingTalk ? location.origin + href : window.location.origin + href;
            isInDingTalk ? location.href = href : newWind.location.href = href;
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // handle click unbind evnet
    // 解绑
    handleClickUnbind (row) {
      console.info(row);
      this.$confirm(
        `
					<h5>是否解除绑定</h5>
					<p style="color:#F56C6C">
						解除绑定后当前绑定的用户将无法使用,
						<span style="color:#666666">您还要继续吗?</span>
					</p>
				`,
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => { });
    },
    // handle click reinvite evnet
    // 重新邀请
    handleClickReinvite (row) {
      console.info(row);
      this.$confirm(
        `
					<h5>是否重新邀请</h5>
					<p style="color:#F56C6C">
						重新发起邀请,之前的邀请将会失效,
						<span style="color:#666666">您还要继续吗?</span>
					</p>
				`,
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => { })
        .catch(() => { });
    },
    // pagination event
    // 分页事件
    handleSizeChange (val) {
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = val;
      this.queryTool();
    },
    handleCurrentChange (val) {
      this.filterModel.itemPage = val;
      this.queryTool();
    }
  }, // methods end
  computed: {
    ...mapGetters(['currentAuthUser']),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    },
    //主账号
    mainAccount () {
      return !this.$store.getters.currentAuthUser.corpUserId;
    },
    // 获取附件中的图片列表，用于预览
    getEnclosureImgList () {
      let a = this.lYDialogData.filter(item => {
        return this.isVideoOrImg(item);
      });
      return a;
    },
    // 获取权限数组菜单
    getPerms () {
      let perms = this.$store.getters.consoleToken;
      perms = perms ? perms.perms : [];
      return perms;
    },
    statusEnum () {
      switch (this.enterpriseSubjectType) {
        case 1:
          return [
            {
              label: "全部",
              value: ""
            },
            {
              label: "待ta签",
              value: "1"
            },
            {
              label: "已完成",
              value: "2"
            },
            {
              label: "已拒签",
              value: "3"
            },
            {
              label: "已过期",
              value: "4"
            },
            {
              label: "已撤销",
              value: "5"
            },
            {
              label: "已作废",
              value: "6"
            }
          ];
        case 2:
          return [
            {
              label: "全部",
              value: ""
            },
            {
              label: "待签署",
              value: "0"
            },
            {
              label: "待ta签",
              value: "1"
            }
          ];
        case 3:
          return [
            {
              label: "全部",
              value: ""
            },
            {
              label: "已完成",
              value: "1"
            },
            {
              label: "已拒签",
              value: "2"
            },
            {
              label: "已过期",
              value: "-6"
            },
            {
              label: "已撤销",
              value: "-5"
            },
            {
              label: "已作废",
              value: "6"
            }
          ];
        default:
          return [
            {
              label: "全部",
              value: ""
            },
            {
              label: "待签署",
              value: "0"
            },
            {
              label: "已完成",
              value: "1"
            },
            {
              label: "已拒签",
              value: "2"
            },
            {
              label: "待审批",
              value: "-3"
            },
            {
              label: "审批驳回",
              value: "-4"
            },
            {
              label: "已撤消",
              value: "-5"
            },
            {
              label: "已过期",
              value: "-6"
            },
            {
              label: "已作废",
              value: "6"
            }
          ]
      }
    },
    nameTextShow () {
      if (this.enterpriseSubjectType) {
        return this.$store.getters.currentAuthUser.corpName ? "-" + this.$store.getters.currentAuthUser.corpName : "-" + this.$store.getters.currentAuthUser.name;
      } else {
        return this.selectTreeNode.groupName ? "-" + this.selectTreeNode.groupName : "";
      }
    },
  },
  destroyed () {
    Bus.$off("$queryContarct");
    Bus.$off('enterpriseSubjectEmit');
  }
};
</script>

<style lang="less" scoped>
/deep/.data-list1 {
  /*height: calc(100vh - 440px);*/
  width: inherit;
  // margin: 0 15px;
  border: 1px solid #cdcdcd;
}
.node_header {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #ed4031;
  border-radius: 6px 6px 0 0;
  background-size: 100%;
  font-size: 16px;
  color: #ffffff;
}
.multiFile {
  position: absolute;
  font-size: 12px;
  top: 0px;
  left: -12px;
  width: 22px;
  height: 16px;
  line-height: 16px;
  background-color: #eb090a;
  color: #ffffff;
  text-align: center;
  border-radius: 4px;
  transform: scale(0.8);
  z-index: 2;

  &:after {
    content: "";
    position: absolute;
    bottom: -4px;
    right: 4px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid #eb090a;
    z-index: 1;
  }
}
.margin-bottom-15 {
  margin-bottom: 15px;
}
.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*color: #290202;*/
  /*opacity: 0.65;*/
}

.dot-gray {
  color: #cccccc;
}

.dot-green {
  color: #20d231;
}

.dot-red {
  color: #f56c6c;
}

.dot-orange {
  color: #e6a23c;
}
.dot-ccc {
  color: #ccc;
}
.dot-purple {
  color: #a68cf5;
}

.right-box {
  /*height: calc(100vh - 205px);*/
  /*overflow: auto;*/
  background: #ffffff;
  border-radius: 2px;

  .contract-box {
    padding: 15px;
  }
}

.color-success {
  color: #290202;
  font-weight: bold;
  margin-right: 6px;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
}

.color-success:hover {
  color: #ec1c1c;
}
/deep/ .ly-info .el-dialog__body {
  height: 420px;
  overflow-y: auto;
}

/deep/ .ly-info .el-dialog__footer {
  text-align: left;
}
.ly-mask {
  .tips {
    color: rgb(115, 90, 90);
    font-size: 12px;
    text-align: left;
  }

  .box-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-left: -20px;
    margin-top: -15px;
    padding: 15px;

    &:last-child {
      /* margin-bottom: 130px; */
    }

    .temone {
      position: relative;
      margin: 15px 0 0 20px;
      width: 175px;
      text-align: center;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;

      &.add {
        cursor: pointer;
        height: 140px;
        line-height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;

        .file-ipt {
          width: inherit;
          height: inherit;
          position: absolute;
          opacity: 0;
        }

        &:hover {
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
        }
      }

      &.temone-center {
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .t-box {
          width: 100%;
          height: 75%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          overflow: hidden;

          .y-img {
            margin-top: 0;
          }
        }

        .tpid {
          width: 100%;
          height: 25%;
          background: #eeeeee;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &:hover {
        .t-box {
          .msk {
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        }

        .has-hover {
          display: block;
        }

        .no-hover {
          display: none;
        }
      }

      .t-box {
        position: relative;
        height: 105px;
        overflow: hidden;

        .y-img {
          width: 46px;
          height: 54px;
          display: block;
          margin: 17px auto 7px auto;
        }

        p {
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 10px;
          width: 100%;
          font-family: Source Han Sans SC;
          color: rgba(41, 2, 2, 0.65);
          box-sizing: border-box;
        }

        .msk {
          transition: all ease 0.2s;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          padding: 8px 8px;
          box-sizing: border-box;

          .des {
            margin-top: 20px;
            font-size: 12px;
            text-align: left;
          }
          p {
            color: rgba(41, 2, 2, 0.65);
          }

          span {
            cursor: pointer;
            color: #ffffff;
            margin-left: 10px;
          }
        }
      }

      .b-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          width: 50%;
        }
      }

      .el-icon-plus {
        cursor: pointer;
        color: #c9bfbf;
        font-size: 80px;
      }
    }
  }

  .a-btn {
    cursor: pointer;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 1);
    text-decoration: none;
    border-radius: 0px 0px 4px 4px;
    background: rgba(239, 239, 239, 1);

    a {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      &:hover {
        color: rgba(236, 28, 28, 1);
      }
    }

    .has-hover {
      display: none;
    }

    .no-hover {
      display: block;
    }
  }
}
.cancel-btn {
  position: absolute;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// components/signInfo/contarctTable.vue